import { buttons } from '@/styles/buttons';

import { SwapIcon } from '@/ui/Icons/SwapIcon';

import {
  MatchaTooltip,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '../../../ui/MatchaTooltip';

export const LimitPriceSwapTokenButton = ({
  disabled,
  inverted,
  tokenSymbol,
  onClick,
}: {
  disabled: boolean;
  inverted: boolean;
  tokenSymbol: string;
  onClick(): void;
}) => {
  const button = (
    <button
      className={buttons({
        size: 'small',
        shape: 'pill',
        color: 'alphaGray',
        class: 'flex-none w-9 p-0',
      })}
      disabled={disabled}
      onClick={onClick}
      aria-label={`Switch price to ${tokenSymbol}`}
    >
      <SwapIcon
        height="16"
        width="16"
        style={{ transform: inverted ? 'rotateY(0deg)' : 'rotateY(180deg)' }}
      />
    </button>
  );

  if (disabled) return button;

  return (
    <MatchaTooltip>
      <MatchaTooltipTrigger>{button}</MatchaTooltipTrigger>
      <MatchaTooltipContent>Switch price to {tokenSymbol}</MatchaTooltipContent>
      <MatchaTooltipPopover />
    </MatchaTooltip>
  );
};
